export const COMPANY_NAME = "Inflection Holdco Inc.";
export const COMPANY_SHORT = "Inflection AI";
export const COMPANY_INITIALS = "IA";
export const COMPANY_ADDRESS_FULL = "15270 Blossom Hill Rd, Los Gatos, CA 95032";
export const COMPANY_LOCATION = "Los Gatos, CA";
export const COMPANY_REGION = "Santa Clara County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=15270%20Blossom%20Hill%20Rd%2C%20Los%20Gatos%2C%20CA%2095032";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Direction", "value": "Personal Intelligence" },
  { "label": "Approach", "value": "Human-centered AI" },
  { "label": "Home", "value": "Los Gatos, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Inflection Holdco Inc." },
  { "label": "Vision", "value": "Future-facing personal intelligence" },
  { "label": "Location", "value": "Los Gatos, California" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Human at the Center", "body": "A future-facing view of AI that starts with human context, curiosity, and agency." },
  { "icon": "✦", "title": "Emotional Intelligence", "body": "Exploring technology that makes dialogue feel more considered, supportive, and useful." },
  { "icon": "◌", "title": "Trusted Agents", "body": "A perspective on AI agents designed to earn trust and create durable, aligned value." },
  { "icon": "⌁", "title": "Future in Motion", "body": "Research and experimentation that help shape the next era of personal intelligence." },
];
